module.exports = {
  transpileDependencies: ['vuetify'],
  publicPath: '/',
  configureWebpack: {
    resolve: {
      alias: {
        '@src': require('path').resolve(__dirname, 'src'),
        '@modules': require('path').resolve(__dirname, 'src/modules'),
        '@components': require('path').resolve(__dirname, 'src/components'),
      },
    },
  },
}
